import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
	children: ReactNode;
	fallback?: ReactNode;
};

type State = {
	hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("ErrorBoundary caught:", error, info.componentStack);
	}

	render() {
		if (this.state.hasError) {
			return (
				this.props.fallback ?? (
					<div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-4">
						<h1 className="text-2xl font-semibold mb-4">Something went wrong</h1>
						<p className="text-gray-500 mb-8">An unexpected error occurred. Please refresh the page and try again.</p>
						<button
							className="px-6 py-2 bg-black text-white rounded"
							onClick={() => window.location.reload()}
						>
							Refresh Page
						</button>
					</div>
				)
			);
		}
		return this.props.children;
	}
}
